<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Salary Pending table</h6>
        <div class="row">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
        </div>
      </div>
      <hr />
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-xs font-weight-bolder">
                  <button type="button" class="btn-success me-3" @click="checkAllList(true)"> Check</button><br /><button type="button" class="btn-primary mt-2" @click="checkAllList(false)" >Uncheck</button>
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Employee
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Basic
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Other
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Details
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Total
                </th>
                <!-- <th class="text-secondary opacity-7"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(salaryPendingObj,index) in paginatedPendingSalary" :key="index">
                <td style="width:10%">
                  <input type="checkbox" id="chk_pending_salary" style="margin-left:30px;transform: scale(1.3);" @click="addPendingSalay(salaryPendingObj.salaryid)" :checked="pendingSalary.includes(salaryPendingObj.salaryid)" :value="salaryPendingObj.salaryid" />
                </td>
                <td class="align-middle text-xs " style="width:10%">
                  <span class="font-weight-bold" >
                    {{ salaryPendingObj.name }}
                    </span>
                </td>
                <td class="align-middle" style="width:20%">
                    <span class="text-xs">Basic: RM</span><span class="font-weight-bold" >{{ salaryPendingObj.basic }} </span><br /> 
                    <span class="text-xs">Hour:</span><span class="font-weight-bold" >{{ salaryPendingObj.hour }}</span><br />
                    <span class="text-xs">OT: RM </span><span class="font-weight-bold" >{{ salaryPendingObj.ot }} </span><br /> 
                    <span class="text-xs">OT Hour:</span><span class="font-weight-bold" >{{ salaryPendingObj.ot_hour }}</span>
                </td>
                <td class="align-middle text-xs " style="width:25%">
                  <span class="font-weight-bold" >
                    Deduct: RM <span style="color: red;">({{ salaryPendingObj.deduct }})</span><br />
                    Duit Makan: RM {{ salaryPendingObj.duitmakan }}<br />
                    Bonus: RM {{ salaryPendingObj.bonus }} <br />
                    Socso: RM {{ salaryPendingObj.socso }} ({{ salaryPendingObj.socso_rate }} %)<br />
                    Epf: RM {{ salaryPendingObj.epf }} ({{ salaryPendingObj.epf_rate }} %)
                    </span>
                </td>
                <td class="align-middle text-xs " style="width:20%">
                  <span class="font-weight-bold" >
                    Salary Date: {{ salaryPendingObj.date }}<br />
                    Remark: {{ salaryPendingObj.remark }}<br />
                    Period: {{ salaryPendingObj.period_desc }}
                  </span>
                </td>
                <td class="align-middle" style="width:15%">
                    <span class="text-xs">Sub Total: RM </span><span class="font-weight-bold" >{{ salaryPendingObj.subtotal }}</span><br />
                    <span class="text-xs">Total: RM </span><span class="font-weight-bold" >{{ salaryPendingObj.total }}</span>
                </td>
              </tr>
              <tr>
                <!-- <td><span class="font-weight-bold">{{ totalSalary.count }}</span></td> -->
                <td><span class="font-weight-bold">Basic:RM {{ totalSalary.basic }}</span></td>
                <td><span class="font-weight-bold">OT:RM {{ totalSalary.ot }}</span></td>
                <td><span class="font-weight-bold">Duit Makan:RM {{ totalSalary.duitmakan }}</span></td>
                <td><span class="font-weight-bold">Bonus:RM {{ totalSalary.bonus }}</span></td>
                <td><span class="font-weight-bold">Deduct:RM {{ totalSalary.deduct }}</span></td>
                <td><span class="font-weight-bold">Total:RM {{ totalSalary.total }}</span></td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-containe">
            <div class="row">
                <div class="col-md-8">
                    <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info me-3">Previous</button>
                    <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
                    <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
                </div>
                <div class="col-md-4">
                    <button class="btn btn-warning" id="btn_cancel" @click="paidSalary(2)">Cancel</button>
                    <button class="btn btn-success" style="margin-left:10px" id="btn_paid" @click="paidSalary(1)">Paid</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
import axios from 'axios';

export default {
  name:'SalaryPendingSelect',
  data(){
    return {
        totalRows: 0,
        currentPage: 0,
        perPage: 5,
        searchQuery:'',
        salaryPendingList:[],
        pendingSalary:[],
        totalSalary:{
          basic:0,
          ot:0,
          duitmakan:0,
          bonus:0,
          total:0,
          count:0,
          deduct:0
        }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.salaryPendingList.length / this.perPage);
    },
    paginatedPendingSalary() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();
      // Filter salaryPendingList by checking all properties in each row
      let filtered = this.salaryPendingList.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.listAllSalaryPending();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    listAllSalaryPending(){
        axios.get('payroll/listAllSalary/0/%/%/%')
            .then(res => {
                this.salaryPendingList = res.data.salaryList;
                this.currentPage = 1;
                this.currentPage = 1;
                this.totalSalary.basic = 0;
                this.totalSalary.ot = 0;
                this.totalSalary.duitmakan = 0;
                this.totalSalary.bonus = 0;
                this.totalSalary.total = 0;
                this.totalSalary.count = 0;
                this.totalSalary.deduct = 0;

                this.salaryPendingList.forEach(element => {
                  this.totalSalary.basic = this.totalSalary.basic + (element.basic * element.hour);
                  this.totalSalary.ot = this.totalSalary.ot + (element.ot * element.ot_hour);
                  this.totalSalary.duitmakan = this.totalSalary.duitmakan + element.duitmakan;
                  this.totalSalary.bonus = this.totalSalary.bonus + element.bonus;
                  this.totalSalary.total = this.totalSalary.total + element.total;
                  this.totalSalary.count = this.totalSalary.count + 1;
                  this.totalSalary.deduct = this.totalSalary.total + element.deduct;
                });
            }).catch(function (error){
                console.log('Error',error.message);
            });
    },
    addPendingSalay(id){
        if (this.pendingSalary.includes(id)) {
            this.pendingSalary = this.pendingSalary.filter(x => x !== id);
        } else {
            this.pendingSalary.push(id);
        }
        // console.log(this.pendingSalary);
    },
    checkAllList(option){
      if(option){
        this.pendingSalary = this.salaryPendingList.map((o) => o.salaryid);
      }else{
        this.pendingSalary = [];
      }
    },
    paidSalary(status){
      let postBody = {
        status: status,
        userid: localStorage.getItem('username'),
        salaryidlist: this.pendingSalary.join(',')
      };
      axios.post('payroll/updateSalaryStatus',postBody)
            .then(res => {
                alert(res.data.message);
                this.listAllSalaryPending();
                this.pendingSalary = [];
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                      alert('Error: username, status and pendingSalaryList is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>